import React from "react";
import { Card } from "react-bootstrap";
import usePaperCompanyValues from "../../_helpers/usePaperCompanyValues";
import { PaperCompanyValues } from "enums/PaperCompanyValues";

interface RegisterStepAccountProps {
    emailAddress: string;
    setEmailAddress: (val: string) => void;
    emailAddressConfirm: string;
    setEmailAddressConfirm: (val: string) => void;
    password: string;
    setPassword: (val: string) => void;
    passwordConfirm: string;
    setPasswordConfirm: (val: string) => void;
    mobilePhone: string;
    handleMobilePhone: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleMobilePhoneKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    agreeToTermsChecked: boolean;
    setAgreeToTermsChecked: (val: boolean) => void;
    registrationError: string;
    activationMessage: string;
    isProcessing: boolean;
    emailAddressRef: React.RefObject<HTMLInputElement>;
    confirmEmailAddressRef: React.RefObject<HTMLInputElement>;
    passwordRef: React.RefObject<HTMLInputElement>;
    confirmPasswordRef: React.RefObject<HTMLInputElement>;
    onBack: () => void;
    onLoginClick: () => void;
    onContinueClick: () => void;
    handleCaptchaStep2: (e: React.FormEvent<HTMLInputElement>) => void;
}

const RegisterStepAccount: React.FC<RegisterStepAccountProps> = ({
    emailAddress,
    setEmailAddress,
    emailAddressConfirm,
    setEmailAddressConfirm,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    mobilePhone,
    handleMobilePhone,
    handleMobilePhoneKeyUp,
    agreeToTermsChecked,
    setAgreeToTermsChecked,
    registrationError,
    activationMessage,
    isProcessing,
    emailAddressRef,
    confirmEmailAddressRef,
    passwordRef,
    confirmPasswordRef,
    onBack,
    onLoginClick,
    onContinueClick,
    handleCaptchaStep2
}) => {
    const { portalTermsOfUseLink, privacyLink } = usePaperCompanyValues({
        portalTermsOfUseLink: { key: PaperCompanyValues.PortalTermsOfUseUrl },
        privacyLink: { key: PaperCompanyValues.PrivacyPolicyUrl }
    });

    return (
        <main>
            <section aria-labelledby="register-form-section">
                <h1 style={{ display: "none" }} aria-labelledby="register-form-section">
                    Registration Form Section
                </h1>
                <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
                    <Card
                        body
                        style={{
                            borderStyle: "none",
                            boxShadow: "0 0 10px 0 rgba(100, 100, 100, 0.26)"
                        }}
                    >
                        <form className="add-form">
                            <div>
                                <input id="hdnInputFocus" type="hidden" autoFocus />
                                <h2>Registration</h2>
                                {registrationError && registrationError.length > 0 ? (
                                    <label
                                        className="text-danger"
                                        aria-live="assertive"
                                        role="alert"
                                    >
                                        {registrationError}
                                        <br />
                                        <br />
                                    </label>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {isProcessing ||
                            (activationMessage && activationMessage.length > 0) ? (
                                <>
                                    {activationMessage && activationMessage.length > 0 ? (
                                        <label>
                                            {activationMessage}&nbsp;
                                            <a href="#" onClick={onLoginClick}>
                                                Log-in Here.
                                            </a>
                                            <br />
                                            <br />
                                        </label>
                                    ) : (
                                        <>
                                            {activationMessage &&
                                            activationMessage.length > 0 ? (
                                                <label>
                                                    {activationMessage}&nbsp;
                                                    <a href="#" onClick={onContinueClick}>
                                                        Continue.
                                                    </a>
                                                    <br />
                                                    <br />
                                                </label>
                                            ) : (
                                                <label>Processing...</label>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <label>
                                        We found your policy, enter the details below to create
                                        your account:
                                        <br />
                                        <br />
                                    </label>
                                    <div>
                                        <label>Email&nbsp;*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={emailAddress}
                                            onChange={(e) =>
                                                setEmailAddress(e.target.value.trim())
                                            }
                                            aria-label="Email Address"
                                            autoFocus
                                            ref={emailAddressRef}
                                        ></input>
                                    </div>
                                    <div>
                                        <label>Re-enter Email&nbsp;*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={emailAddressConfirm}
                                            onChange={(e) =>
                                                setEmailAddressConfirm(e.target.value.trim())
                                            }
                                            aria-label="Email Address confirm"
                                            ref={confirmEmailAddressRef}
                                        ></input>
                                    </div>
                                    <div>
                                        <label>Password&nbsp;*</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder=""
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value.trim())}
                                            aria-label="Password"
                                            ref={passwordRef}
                                        ></input>
                                    </div>
                                    <div>
                                        <label>Re-enter Password&nbsp;*</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder=""
                                            value={passwordConfirm}
                                            onChange={(e) =>
                                                setPasswordConfirm(e.target.value.trim())
                                            }
                                            aria-label="Re-enter Password"
                                            ref={confirmPasswordRef}
                                        ></input>
                                    </div>
                                    <div>
                                        <label>Mobile Phone</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={mobilePhone}
                                            onChange={handleMobilePhone}
                                            onKeyUp={handleMobilePhoneKeyUp}
                                            aria-label="Mobile Phone Number"
                                        ></input>
                                    </div>
                                    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div style={{ display: "flex", alignItems: "flex-start" }}>
                                            <input
                                                type="checkbox"
                                                id="agreeToTerms"
                                                checked={agreeToTermsChecked}
                                                onChange={() =>
                                                    setAgreeToTermsChecked(!agreeToTermsChecked)
                                                }
                                                style={{ marginTop: "4px", marginRight: "8px" }}
                                                aria-label="Agree to Terms and Conditions and Privacy Policy"
                                            ></input>
                                            <label htmlFor="agreeToTerms" style={{ marginBottom: "0" }}>
                                                I understand and agree with the{" "}
                                                <a
                                                    href={portalTermsOfUseLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Terms &amp; Conditions
                                                </a>{" "}
                                                and{" "}
                                                <a
                                                    href={privacyLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Privacy Policy
                                                </a>
                                                . Registration confirmation will be emailed to you.
                                            </label>
                                        </div>
                                    </div>
                                    {isProcessing ? (
                                        <label>Processing...</label>
                                    ) : (
                                        <>
                                            <input
                                                type="button"
                                                value="Back"
                                                className="btnRounded"
                                                onClick={onBack}
                                                aria-label="Back button"
                                            ></input>
                                            {/* TODO: Need to replace button with spinner so user can't do multiple submits */}
                                            <input
                                                type="button"
                                                value="Submit"
                                                className="btnRounded"
                                                onClick={handleCaptchaStep2}
                                                aria-label="Submit button"
                                            ></input>
                                        </>
                                    )}
                                </>
                            )}
                        </form>
                    </Card>
                </div>
            </section>
        </main>
    );
};

export default RegisterStepAccount;
